// extracted by mini-css-extract-plugin
export var activityContainer = "_iu-0";
export var typingIndicatorContainer = "_iu-1";
export var typingIndicatorDot = "_iu-2";
export var wave = "_iu-3";